import { Navigate } from "react-router-dom";
import { LoadingLogo } from "@/components/shared/LoadingLogo";
import { useCommunityPageEnabled } from "@/hooks/useCommunityPageEnabled";

export function CommunityRouteGuard({ children }: { children: React.ReactNode }) {
  const { data: enabled, isLoading } = useCommunityPageEnabled();

  if (isLoading) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <LoadingLogo label="Loading..." />
      </div>
    );
  }

  if (!enabled) {
    return <Navigate to="/CFA/home" replace />;
  }

  return <>{children}</>;
}
